import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';

import { connectModal } from '../../../features/modal/hoc';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import {
  selectLoans,
  selectLoansPagination,
  selectLoansFilter,
  fetchAccountLoansActions,
  setAccountLoansFilterAction,
} from '../../../features/account-management/ducks';
import { LoanList } from '../../../features/loan-management/components';
import { apiCallIds as loanApiCallIds } from '../../../features/loan-management/api';
import { selectAccount, selectAccountFullName } from '../ducks';

const mapStateToProps = state => ({
  loans: selectLoans(state),
  pagination: selectLoansPagination(state),
  filter: selectLoansFilter(state),
  isLoadingLoans: selectIsInProgress(state, loanApiCallIds.FETCH_LOANS),
  account: selectAccount(state),
  accountFullName: selectAccountFullName(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccountLoans: fetchAccountLoansActions.request,
      setFilter: setAccountLoansFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  status: 'AKT',
};

export const LOAN_LIST_MODAL = 'paymentManagement/modals/LOAN_LIST_MODAL';

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(LOAN_LIST_MODAL)
export default class LoanListModal extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    account: PropTypes.object,
    accountFullName: PropTypes.string.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoadingLoans: PropTypes.bool.isRequired,
  };

  onModalMount = () => {
    const { account, actions } = this.props;
    actions.setFilter({
      ...defaultFilter,
      accountId: account.id,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAccountLoans({
      ...this.props.filter,
      accountId: this.props.account.id,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { account, filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
      accountId: account.id,
    });
  };

  onFilterStatusChange = this.onFilterChange('status');

  render() {
    const {
      account,
      accountFullName,
      modalActions,
      isLoading,
      isVisible,
      loans,
      pagination,
      filter,
      isLoadingLoans,
      onSubmit,
    } = this.props;

    return (
      <span>
        {account &&
          isVisible && (
            <ModalWindow
              accountFullName={accountFullName}
              hideModal={modalActions.hide}
              isLoading={isLoading}
              onSubmit={onSubmit}
              filter={filter}
              onFilterStatusChange={this.onFilterStatusChange}
              loans={loans}
              pagination={pagination}
              handleTableChange={this.handleTableChange}
              isLoadingLoans={isLoadingLoans}
              onModalMount={this.onModalMount}
            />
          )}
      </span>
    );
  }
}

@translate()
class ModalWindow extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    handleTableChange: PropTypes.func.isRequired,
    isLoadingLoans: PropTypes.bool.isRequired,
    onModalMount: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onModalMount();
  }

  render() {
    const {
      t,
      accountFullName,
      hideModal,
      isLoading,
      onSubmit,
      filter,
      onFilterStatusChange,
      loans,
      pagination,
      handleTableChange,
      isLoadingLoans,
    } = this.props;

    return (
      <Modal
        title={t('Zvoľte pôžičku')}
        visible
        confirmLoading={isLoading}
        onCancel={hideModal}
        footer={[
          <Button size="small" key="back" onClick={hideModal}>
            {t('Zrušiť')}
          </Button>,
        ]}
        width={1500}
      >
        <h2>{accountFullName}</h2>
        <LoanList
          loans={loans}
          pagination={pagination}
          filter={filter}
          onTableChange={handleTableChange}
          onFilterStatusChange={onFilterStatusChange}
          isLoading={isLoadingLoans}
          actions={(text, loan) => (
            <Button size="small" onClick={() => onSubmit(loan.id)}>
              {t('Priradiť')}
            </Button>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/components/LoanListModal.js